// extracted by mini-css-extract-plugin
export default {"link":"Positions_link__X1gs4","applySection":"Positions_applySection__TDZre"};